import axios from 'axios';
import { apiUrl} from'../Config/Config';

const mem_plan = () => {
    var qs = require('qs');
    let planLists = [];
    var postobject = {
        admin_id : localStorage.getItem('admin_id')
    };
    axios.post(apiUrl+"membership/plantypes",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let planlist = res.data.planlist;
            
            for(i; i<planlist.length; i++){
                planLists[i] = { value: planlist[i]['mem_cat_id'], label: lang.Capitalize(planlist[i]['category_for'])+" - "+planlist[i]['category'], type : planlist[i]['category_for']  };
            }
            
        }       
    });
    return planLists;
}

const domainList = () => {
    var qs = require('qs');

    let domainlist = [];
    var postobject = {
admin_id : localStorage.getItem('admin_id')

    };

        axios.post(apiUrl+"user/domainlist",qs.stringify(postobject)).then(res => {

        if(res.data.status == "success"){
            let i=0;
            let domainlists = res.data.domainlist;
            
            for(i; i<domainlists.length; i++){
                domainlist[i] = { value: domainlists[i]['domain_id'], label: domainlists[i]['domain_name'] };
            }
            
        }       
    });
   
    return domainlist;
}
const companyList = () => {
    var qs = require('qs');

    let companyList = [];
    var postobject = {
    admin_id : localStorage.getItem('admin_id')
    };

        axios.post(apiUrl+"company/companyList",qs.stringify(postobject)).then(res => {

        if(res.data.status == "success"){
            let i=0;
            let companyLists = res.data.companyList;
            
            for(i; i<companyLists.length; i++){
                companyList[i] = { value: companyLists[i]['id'], label: companyLists[i]['company_name'] };
            }
            
        }       
    });
   
    return companyList;
}

{/*const categories = () => {
    var qs = require('qs');
    var postobject = {};

    let catelists = [];
    axios.post(apiUrl+"faq/categories",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let catelist = res.data.catelist;
            
            for(i; i<catelist.length; i++){
                catelists[i] = { value: catelist[i]['id'], label: catelist[i]['cate_name'] };
            }
            
        }       
    });
    return catelists;
}

const categories1 = () => {
    var qs = require('qs');

    var postobject = {
        type: 'all'
    };

    let catelists = [];
    axios.post(apiUrl+"faq/categories",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let catelist = res.data.catelist;
            
            for(i; i<catelist.length; i++){
                catelists[i] = { value: catelist[i]['id'], label: catelist[i]['cate_name'] };
            }
            
        }       
    });
    return catelists;
}*/}

const adcategories = () => {
    var qs = require('qs');
    var postobject = {};

    let catelists = [];
    axios.post(apiUrl+"advertisement/categories",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let catelist = res.data.catelist;
            
            for(i; i<catelist.length; i++){
                catelists[i] = { value: catelist[i]['id'], label: catelist[i]['cate_name'] };
            }
            
        }       
    });
    return catelists;
}
const guidecategories = () => {
    var qs = require('qs');
    var postobject = {};

    let catelists = [];
    axios.post(apiUrl+"guidecategory/categories",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let catelist = res.data.catelist;
            
            for(i; i<catelist.length; i++){
                catelists[i] = { value: catelist[i]['id'], label: catelist[i]['cate_name'] };
            }
            
        }       
    });
    return catelists;
}
const guidesubcategories = () => {
    var qs = require('qs');
    var postobject = {};

    let catelists = [];
    axios.post(apiUrl+"guidesubcategory/sub_categories",qs.stringify(postobject)).then(res => {
        if(res.data.status == "success"){
            let i=0;
            let catelist = res.data.catelist;
            
            for(i; i<catelist.length; i++){
                catelists[i] = { value: catelist[i]['id'], label: catelist[i]['sub_cate_name'] };
            }
            
        }       
    });
    return catelists;
}
const year_list = () => {

    let years = [];  
    let start_yr = 1950;
    let end_yr = new Date().getFullYear();
    let diff = end_yr - start_yr;
    // console.log(end_yr, 'end_yr');
    // console.log(diff, 'diff');
    let i=0;
    for(i; i<=diff; i++){
        let opt = start_yr + i;
        years[i] = { value: opt, label: opt };
    }
    return years;
}
export const lang = {

    common: {
        title:'Carbooking 2.0',
        status_option:[
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' },
        ],
        status_filter_option:[
            { value: '', label: 'All' },
            { value: 'A', label: 'Active' },
            { value: 'I', label: 'Inactive' },
        ],
         memb_cat_for_option:[
            { value: 'company', label: 'Company' },
            { value: 'driver', label: 'Driver' },
            { value: 'rider', label: 'Rider' },
            { value: 'business', label: 'Business' },
            { value: 'advertiser', label: 'Advertiser' },
            { value: 'truck driver', label: 'Truck Driver' },
            { value: 'insurance company', label: 'Insurance Company' },
            { value: 'institute', label: 'Institute' },
        ],
        status_filter_option1:[
            { value: '', label: 'All' },
            { value: 'Yes', label: 'Active' },
            { value: 'No', label: 'Inactive' },
        ],
        advertisement_linktype:[
            { value: 'external', label: 'External' },
            { value: 'internal', label: 'Internal' },
            { value: 'offer', label: 'Offer' },
        ],
        //categories_option: categories(),
       // categories_option1: categories1(),
       adcategories_option: adcategories(),
       guidecategories_option: guidecategories(),
       guidesubcategories_option: guidesubcategories(),
        gender_option: [
            { value: 'Male', label: 'Male' },
            { value: 'Female', label: 'Female' },
            { value: 'Transgender', label: 'Transgender' }
        ],
		/* image_size_option: [
            { value: '250x250', label: '250x250' },
			{ value: '350x350', label: '350x350' },
            { value: '520x520', label: '520X520' }
        ],*/
        image_size_option: [
            { value: '1031x400', label: '1031x400 (W X H)' },
            { value: '250x180', label: '250x180 (W X H)' },
			{ value: '200x150', label: '200x150 (W X H)' },
            { value: '180x120', label: '180x120 (W X H)' }
        ],
        coming_source :[
            { value: '0', label: 'Select' },
            { value: 'friends', label: 'Friends' },
            { value: 'facebook', label: 'Facebook' },
            { value: 'instagram', label: 'Instagram' },
            { value: 'messaging apps', label: 'Messaging Apps' },
            { value: 'website', label: 'Website' },
            { value: 'flyers', label: 'Flyers' },
            { value: 'sms', label: 'Sms' },
            { value: 'newspaper', label: 'Newspapers' },
            { value: 'others', label: 'Others' }
        ],
        //  field_options :[
        //     { value: 'text', label: 'Text' },
        //     { value: 'email', label: 'Email' },
        //     { value: 'tel', label: 'Tel' },
        //     { value: 'textarea', label: 'Textarea' },
        //     { value: 'password', label: 'Password' },
        //     { value: 'select', label: 'Select' },
        //     { value: 'checkbox', label: 'Checkbox' },
        //     { value: 'radio', label: 'Radio' },
        //     { value: 'url', label: 'url' },
        //     { value: 'image', label: 'Image' },
        // ],

        dashboard_page_options :[
            { value: 'frontScreenSt', label: 'Guest`s Book',type: 'Guest'},
            { value: 'commonMembershipSt', label: 'Guest`s Membership',type: 'Guest'},

            { value: 'frontScreenSt', label: 'User`s Book',type: 'User'},  
            { value: 'userCreditPointSt', label: 'User`s Credit Points',type: 'User'},            
            { value: 'userMyRideSt', label: 'User`s New Rides',type: 'User'},           
            { value: 'userRecentRideSt', label: 'User`s Recent Rides',type: 'User'},           
            { value: 'userFavoriteRideSt', label: 'User`s Favorite Rides',type: 'User'},           
            { value: 'userCancelRideSt', label: 'User`s Cancelled Rides',type: 'User'},           
            { value: 'userFamilyMemberSt', label: 'User`s Family Members',type: 'User'},           
            { value: 'userStopTempSt', label: 'User`s Trip Templates',type: 'User'},           
            
            { value: 'driverPickRideSt', label: 'Driver`s Ride Management',type: 'Driver'},
            // { value: 'driverAcctSt', label: 'Driver`s Account Management',type: 'Driver'},
            //{ value: 'driverBonusRewardSt', label: 'Driver`s Bonus Reward',type: 'Driver'},
            //{ value: 'driverClaimRewardSt', label: 'Driver`s Claim Reward',type: 'Driver'},
            {value: 'driverMyRewardSt', label: 'Driver`s Rewards', type : 'Driver' },
            {value: 'driverdetailsViewSt', label: 'Driver Profile', type : 'Driver'},
            {value: 'driverMyTransact', label: 'Driver My Earnings', type : 'Driver'},
            {value: 'driverMembSt', label: 'Driver Membership', type : 'Driver'},
            {value: 'driverCardMangSt', label: 'Driver Payment Methods', type : 'Driver'},
            {value: 'drivermyOutstandingSt', label: 'Driver My Outstanding', type : 'Driver'},
            {value: 'drivermyInvitesSt', label: 'Driver My Invites', type : 'Driver'},
            {value: 'driverMyReferrerSt', label: 'Driver My Referrer', type : 'Driver'},
            {value: 'driverMonthlyEarningsSt', label: 'Driver Monthly Earnings', type : 'Driver'},
            {value: 'driverYearlyEarningsSt', label: 'Driver Early Earnings', type : 'Driver'},
            {value: 'driverRecurringPaymentSt', label: 'Driver Recurring Payments', type : 'Driver'},
            {value: 'showMyBankAccountSt', label: 'Driver Bank Account', type : 'Driver'},
            {value: 'driverFavCustomerSt', label: 'Driver Favourite Customers', type : 'Driver'},
            {value: 'allNotificationSt', label: 'Driver Notifications', type : 'Driver'},


            
            { value: 'frontScreenSt', label: 'Company`s Book',type: 'Company'},        
            { value: 'companyUserSt', label: 'Company`s Customers',type: 'Company'},
            { value: 'companyDriverSt', label: 'Company`s Drivers',type: 'Company'},
            { value: 'companyCreateRideSt', label: 'Company`s Rides',type: 'Company'},
            { value: 'companyPickRideSt', label: 'Company`s New Rides',type: 'Company'},
            { value: 'companyMyRideSt', label: 'Company`s Accepted Rides',type: 'Company'},           
            { value: 'companyCompletedRideSt', label: 'Company`s Completed Rides',type: 'Company'},           
            { value: 'companyTripSt', label: 'Company`s Trip Templates',type: 'Company'},   
            { value: 'companyMyRewardSt', label: 'Company`s Rewards', type: 'Company' },   
            
            { value: 'adminDriverSt', label: 'Admin`s Drivers',type: 'Admin'},
            { value: 'adminUserSt', label: 'Admin`s Customers',type: 'Admin'},
            { value: 'adminCompanyRideSt', label: 'Admin`s Company Rides',type: 'Admin'},
            { value: 'adminPickRideSt', label: 'Admin`s New Rides',type: 'Admin'},
            { value: 'adminMyRideSt', label: 'Admin`s Accepted Rides',type: 'Admin'},
            { value: 'adminCompletedRideSt', label: 'Admin`s Completed Rides',type: 'Admin'},
            { value: 'adminBonusRewardSt', label: 'Admin`s Bonus Reward',type: 'Admin'},
            { value: 'adminClaimRewardSt', label: 'Admin`s Claim Reward',type: 'Admin'},
            
        ],
        landingPageOptions :[
       // { value: 'MainTab', label: 'Main' },
        { value: 'aiScreen', label: 'AI Screen' },
        { value: 'mainTab', label: 'Main Tab' },       
        { value: 'adsTab', label: 'Ads' }
        ],
         pluginPosition :[
        { value: 'fixed', label: 'Fixed' },       
        { value: 'absolute', label: 'Absolute' }
        ],
        discount_option:[
            { value: 'percentage', label: 'Percentage' },
            { value: 'standard', label: 'Flat' },
            { value: 'bonusDouble', label: 'Double Mile Credits' },
            { value: 'bonusFlat', label: 'Credit Point' },
        ],
        discount_type:[
            { value: 'Percentage', label: 'Percentage' },
            { value: 'Flat', label: 'Flat' },
        ],
		 shortcuticon_options :[     
            { value: 'ai', label: 'AI' },
            { value: 'profile', label: 'Profile' },            
            { value: 'dashboard', label: 'Dashboard'},
            { value: 'advertisementSt', label: 'Advertisement'},   
            { value: 'guideShow', label: 'Guide'}, 
			{ value: 'userFavoriteRideSt', label: 'User`s Favorite Rides'},
			{ value: 'frontScreenSt', label: 'Book'},    
        ],
        // module_option:[
        //     { value: 'module1', label: 'Module1 (Doctor Listing)' },
        //     { value: 'module2', label: 'Module2 (Product Listing)' },
        // ],
        // productType_option:[
        //     { value: '1', label: 'Normal Product' },
        //     { value: '2', label: 'Shopping Product' },
        //     { value: '3', label: 'Regular Product' },
        // ],
        period_option: [
            // { value: 'Day', label: 'Day' },
            // { value: 'Month', label: 'Month' },
            // { value: 'Year', label: 'Year' }
            { value: 'day', label: 'Daily' },
            { value: 'week', label: 'Week' },
            { value: 'month', label: 'Month' },
            { value: 'year', label: 'Year' }
        ],
        userType_option:[
            { value: 'all', label: 'All' },
            { value: 'User', label: 'User' },
            { value: 'Driver', label: 'Driver' },
            { value: 'Company', label: 'Company' },
            { value: 'Admin', label: 'Admin' },
            { value: 'Guest', label: 'Guest' },
            
        ],
        
        linkto_option:[
            { value: 'frontScreenSt', label: 'Book' },
            // { value: 'mainAiScreenSt', label: 'Home' },
            { value: 'mainAiScreenSt', label: 'AI Chat' },
            { value: 'guideShow', label: 'Guide' },
            { value: 'advertisementSt', label: 'Ads' },
            { value: 'companyDashSt', label: 'Company Dashboard' },
            { value: 'userDashSt', label: 'User Dashboard' },
            { value: 'driverDashSt', label: 'Driver Dashboard' },
            { value: 'companyDashSt', label: 'Company Dashboard' },
            { value: 'adminDashSt', label: 'Admin Dashboard' },
            { value: 'userMembSt', label: 'User Membership' },
            { value: 'driverMembSt', label: 'Driver Membership' },
            { value: 'companyMembSt', label: 'Company Membership' },
            { value: 'commonMembershipSt', label: 'Common Membership' },
            { value: 'userCreditPointSt', label: 'User Credit Points' },
            { value: 'driverMyRewardSt', label: 'Driver Rewards' },
            { value: 'companyMyRewardSt', label: 'Company Rewards' },
            { value: 'adminCommonMessageSt', label: 'Admin Send Message' },
            { value: 'storePageSt', label: 'Stores' },
            { value: 'userWalletPlanSt', label: 'User Wallet Plans' },
            
        ],

        userTypeOption:[
            { value: 'Guest', label: 'Guest' },
            { value: 'User', label: 'User' },
            { value: 'Driver', label: 'Driver' },
            { value: 'Company', label: 'Company' },
            { value: 'Admin', label: 'Admin' },
        ],

        pageOption :[
            { value: 'mainShortViewSt', label: 'Shortform Embed', type: 'Guest'},
            { value: 'frontScreenSt', label: 'Book Your Ride', type: 'Guest'},
            { value: 'commonMembershipSt', label: 'Common Membership', type: 'Guest' },

            { value: 'frontScreenSt', label: 'User`s Book', type: 'User'}, 
            { value: 'commonMembershipSt', label: 'User`s Membership', type: 'User' },
            { value: 'userCreditPointSt', label: 'User`s Credit Points',type: 'User'},            
            { value: 'userMyRideSt', label: 'User`s Ride Management', type: 'User'}, 
            { value: 'userFamilyMemberSt', label: 'User`s Family Members', type: 'User'},           
            { value: 'userStopTempSt', label: 'User`s Trip Templates', type: 'User'},           
            // { value: 'userRecentRideSt', label: 'User`s Recent Rides', type: 'User'},           
            // { value: 'userFavoriteRideSt', label: 'User`s Favorite Rides', type: 'User'},           
            // { value: 'userCancelRideSt', label: 'User`s Cancelled Rides', type: 'User'},            
            // { value: 'userDashSt', label: 'User`s Dashboard', type: 'User'},  
                     
            
            { value: 'driverMembSt', label: 'Driver`s Membership', type: 'Driver'},
            { value: 'driverPickRideSt', label: 'Driver`s Ride Management', type: 'Driver'},
            { value: 'driverMyRewardSt', label: 'Driver`s My Rewards', type: 'Driver'},
            { value: 'drivermyInvitesSt', label: 'Driver`s My Invites', type: 'Driver'},
            { value: 'storePageSt', label: 'Driver`s Stores', type: 'Driver'},
            
            // { value: 'driverCompanyRideSt', label: 'Driver`s Company Rides', type: 'Driver'},
            // { value: 'driverMyRideSt', label: 'Driver`s Accepted Rides', type: 'Driver'},
            // { value: 'driverCompletedRideSt', label: 'Driver`s Completed Rides', type: 'Driver'},
            // { value: 'driverCancelRideSt', label: 'Driver`s Cancel Rides', type: 'Driver'},
            // { value: 'driverAcctSt', label: 'Driver`s Account Management', type: 'Driver'},
            // { value: 'driverBonusRewardSt', label: 'Driver`s Bonus Reward', type: 'Driver'},
            // { value: 'driverClaimRewardSt', label: 'Driver`s Claim Reward', type: 'Driver'},
            // { value: 'driverMyRewardSt', label: 'Driver Rewards', type : 'Driver' },            
            
            { value: 'frontScreenSt', label: 'Company`s Book', type: 'Company'},
            { value: 'companyMembSt', label: 'Company`s Membership Page', type: 'Company'},        
            { value: 'companyUserSt', label: 'Company`s Customers', type: 'Company'},
            { value: 'companyDriverSt', label: 'Company`s Drivers', type: 'Company'},
            { value: 'companyCreateRideSt', label: 'Company`s Ride Management', type: 'Company'},
            { value: 'companyTripSt', label: 'Company`s Trip Templates', type: 'Company'},   
            { value: 'companyMyRewardSt', label: 'Company Rewards', type: 'Company' }, 
            { value: 'companyVehicleListSt', label: 'Company Vehicle Management', type: 'Company'},
            // { value: 'companyPickRideSt', label: 'Company`s New Rides', type: 'Company'},
            // { value: 'companyMyRideSt', label: 'Company`s Accepted Rides', type: 'Company'},           
            // { value: 'companyCompletedRideSt', label: 'Company`s Completed Rides', type: 'Company'},           
             
            
            { value: 'adminDriverSt', label: 'Admin`s Drivers', type: 'Admin'},
            { value: 'adminUserSt', label: 'Admin`s Customers', type: 'Admin'},
            { value: 'adminPickRideSt', label: 'Admin`Ride Manangement', type: 'Admin'},
            { value: 'adminBonusRewardSt', label: 'Admin`s Bonus Reward', type: 'Admin'},
            { value: 'adminClaimRewardSt', label: 'Admin`s Claim Reward', type: 'Admin'},
            // { value: 'adminCompanyRideSt', label: 'Admin`s Company Rides', type: 'Admin'},
            // { value: 'adminMyRideSt', label: 'Admin`s Accepted Rides', type: 'Admin'},
            // { value: 'adminCompletedRideSt', label: 'Admin`s Completed Rides', type: 'Admin'},
           
            
        ],
        field_options :[
            { value: 'mainShortViewSt', label: 'Shortform Embed', type: 'Guest'},
            { value: 'frontScreenSt', label: 'Book Your Ride', type: 'Guest'},
            { value: 'commonMembershipSt', label: 'Common Membership', type: 'Guest' },

            { value: 'frontScreenSt', label: 'User`s Book', type: 'User'}, 
            { value: 'commonMembershipSt', label: 'User`s Membership', type: 'User' },
            { value: 'userCreditPointSt', label: 'User`s Credit Points',type: 'User'},            
            { value: 'userMyRideSt', label: 'User`s Ride Management', type: 'User'}, 
            { value: 'userFamilyMemberSt', label: 'User`s Family Members', type: 'User'},           
            { value: 'userStopTempSt', label: 'User`s Trip Templates', type: 'User'},           
            // { value: 'userRecentRideSt', label: 'User`s Recent Rides', type: 'User'},           
            // { value: 'userFavoriteRideSt', label: 'User`s Favorite Rides', type: 'User'},           
            // { value: 'userCancelRideSt', label: 'User`s Cancelled Rides', type: 'User'},            
            // { value: 'userDashSt', label: 'User`s Dashboard', type: 'User'},  
                     
            
            { value: 'driverMembSt', label: 'Driver`s Membership', type: 'Driver'},
            { value: 'driverPickRideSt', label: 'Driver`s Ride Management', type: 'Driver'},
            { value: 'driverMyRewardSt', label: 'Driver`s My Rewards', type: 'Driver'},
            { value: 'drivermyInvitesSt', label: 'Driver`s My Invites', type: 'Driver'},
            { value: 'storePageSt', label: 'Driver`s Stores', type: 'Driver'},
            
            // { value: 'driverCompanyRideSt', label: 'Driver`s Company Rides', type: 'Driver'},
            // { value: 'driverMyRideSt', label: 'Driver`s Accepted Rides', type: 'Driver'},
            // { value: 'driverCompletedRideSt', label: 'Driver`s Completed Rides', type: 'Driver'},
            // { value: 'driverCancelRideSt', label: 'Driver`s Cancel Rides', type: 'Driver'},
            // { value: 'driverAcctSt', label: 'Driver`s Account Management', type: 'Driver'},
            // { value: 'driverBonusRewardSt', label: 'Driver`s Bonus Reward', type: 'Driver'},
            // { value: 'driverClaimRewardSt', label: 'Driver`s Claim Reward', type: 'Driver'},
            // { value: 'driverMyRewardSt', label: 'Driver Rewards', type : 'Driver' },            
            
            { value: 'frontScreenSt', label: 'Company`s Book', type: 'Company'},
            { value: 'companyMembSt', label: 'Company`s Membership Page', type: 'Company'},        
            { value: 'companyUserSt', label: 'Company`s Customers', type: 'Company'},
            { value: 'companyDriverSt', label: 'Company`s Drivers', type: 'Company'},
            { value: 'companyCreateRideSt', label: 'Company`s Ride Management', type: 'Company'},
            { value: 'companyTripSt', label: 'Company`s Trip Templates', type: 'Company'},   
            { value: 'companyMyRewardSt', label: 'Company Rewards', type: 'Company' }, 
            { value: 'companyVehicleListSt', label: 'Company Vehicle Management', type: 'Company'},
            // { value: 'companyPickRideSt', label: 'Company`s New Rides', type: 'Company'},
            // { value: 'companyMyRideSt', label: 'Company`s Accepted Rides', type: 'Company'},           
            // { value: 'companyCompletedRideSt', label: 'Company`s Completed Rides', type: 'Company'},           
             
            
            { value: 'adminDriverSt', label: 'Admin`s Drivers', type: 'Admin'},
            { value: 'adminUserSt', label: 'Admin`s Customers', type: 'Admin'},
            { value: 'adminPickRideSt', label: 'Admin`Ride Manangement', type: 'Admin'},
            { value: 'adminBonusRewardSt', label: 'Admin`s Bonus Reward', type: 'Admin'},
            { value: 'adminClaimRewardSt', label: 'Admin`s Claim Reward', type: 'Admin'},
            // { value: 'adminCompanyRideSt', label: 'Admin`s Company Rides', type: 'Admin'},
            // { value: 'adminMyRideSt', label: 'Admin`s Accepted Rides', type: 'Admin'},
            // { value: 'adminCompletedRideSt', label: 'Admin`s Completed Rides', type: 'Admin'},
           
            
        ],

        sidetabmenu_option:[
            { value: 'all', label: 'All' },
            { value: 'aisidemenu', label: 'AI Side Menu' },
            { value: 'maintab', label: 'Main Tab' },
            
        ],
        rewardTypeOption:[
            { value: 'normal', label: 'Normal' },
            { value: 'peakHours', label: 'Peak Hours' },
            { value: 'offRoadRide', label: 'Off Road Ride' },
            
        ],

        contentType_option:[
            { value: 'description', label: 'Description' },
            { value: 'form', label: 'Form' },
            { value: 'listing', label: 'Listing' },
            { value: 'membership', label: 'Membership' },
            
        ],
        timing_option:[
            { value: '05', label: '+05' },
            { value: '10', label: '+10' },
            { value: '15', label: '+15' },
            { value: '20', label: '+20' },
            { value: '25', label: '+25' },
            { value: '30', label: '+30' },
            { value: '35', label: '+35' },
            { value: '40', label: '+40' },
            { value: '45', label: '+45' },
            { value: '50', label: '+50' },
            { value: '55', label: '+55' },
            { value: '60', label: '+60' },
        ],
        mins_option:[
            { value: '05', label: '05' },
            { value: '10', label: '10' },
            { value: '15', label: '15' },
            { value: '20', label: '20' },
            { value: '25', label: '25' },
            { value: '30', label: '30' },
            { value: '35', label: '35' },
            { value: '40', label: '40' },
            { value: '45', label: '45' },
            { value: '50', label: '50' },
            { value: '55', label: '55' },
            { value: '60', label: '60' },
        ],
        dashboard_img_position:[
            { value: 'top-left', label: 'Top left' },
            { value: 'top-right', label: 'Top right' },
            { value: 'top-center', label: 'Top center' },
            { value: 'middle-left', label: 'Middle left' },
            { value: 'middle-center', label: 'Center' },
            { value: 'middle-right', label: 'Middle right' },
            { value: 'bottom-left', label: 'Bottom left' },
            { value: 'bottom-right', label: 'Bottom right' },
            { value: 'bottom-center', label: 'Bottom center' },
        ],
        notification_type:[
            { value: 'common', label: 'Common' },
            // { value: 'ride_notify_all', label: 'New ride notification to all driver and company' },
            { value: 'ride_common', label: 'Ride Notification' },
            { value: 'credit_point', label: 'Credit Point' },
            { value: 'payment', label: 'Payment' },
            { value: 'coupon', label: 'Coupon' },
            {value:'reward', label:"Reward"}
        ],
        dashboard_blocks :[            
            { value: 'block1', label: 'BLOCK A', columncount:4},
            { value: 'block2', label: 'BLOCK B', columncount:4},
            { value: 'block3', label: 'BLOCK C', columncount:3}, 
            // { value: 'block4', label: 'block D', columncount:3},  
        ],
        







        domainList_option:domainList(),
        companyList_option:companyList(),
        mem_plan_option: mem_plan(),
        year_option: year_list(),
        

    },
    Capitalize(str){
        return str.charAt(0).toUpperCase() + str.slice(1);
        }
};


